import Model from "flarum/Model";

export default class U2DiInviteCode extends Model {}
Object.assign(U2DiInviteCode.prototype, {
  id: Model.attribute("id"),
  codeType: Model.attribute("codeType"),
  userType: Model.attribute("userType"),
  realName: Model.attribute("realName"),
  validDuration: Model.attribute("validDuration"),
  inviteCode: Model.attribute("inviteCode"),
  currentDate: Model.attribute("currentDate"),
  assignedAt: Model.attribute("assignedAt"),
  usedAt: Model.attribute("usedAt"),
  u2diUserData: Model.hasOne("u2diUserData"),
});